var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "138px",
    height: "68px",
    viewBox: "-0.5 -0.5 138 68",
    content: "<mxfile host=\"Electron\" modified=\"2023-09-04T15:13:45.945Z\" agent=\"5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/13.7.9 Chrome/85.0.4183.121 Electron/10.1.3 Safari/537.36\" etag=\"SS3FME7tNEfep2YNrjRA\" version=\"13.7.9\" type=\"device\"><diagram id=\"b-_DrRomCUJmS8_--Cps\" name=\"Page-1\">lZNdb4MgFIZ/jZdLFOzXZWu7LkuaNeuSXRM5UzIUh/TD/fphARXNki3pBTyc88J5fRvgpLjtJanyg6DAAxTSW4C3AUJRjFDQ/kLaGLKMsQGZZNSgsAcn9g2209Ezo1BbZpASgitW+TAVZQmp8hiRUlz9sg/BqQcqksEEnFLCp/SdUZXbKdCi50/AstzdHM1X5qQgrthOUueEiusA4V2AEymEMqvilgBvzfN9efzltHuYhFL9peE1OjRos9w/H5stfjvh9Rd5ebBf50L42Q5sH6sa5wCUdN0aqXcpJ3XN0gBvclVwDSK9rJUUn5AILuS9AePVfLaA7sTZFmGNjDrQien9FFHnjQ4ViAKUbHTJtXd/Zh3NB8Y7JoETxS6+PLEhyDq57oajYPpiFNrAotjq2LjGYehL1OIsU7BdQ7dHQng2EopHQorIDNRESFtNmkFZ1RbU/3hw7KVAL4yi2w087dE9KW7bJ9KU9/9rvPsB</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13 13 L 13 43 Q 13 53 23 53 L 94.22 53",
    fill: "none",
    stroke: "#39657e",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 108.47 53 L 89.47 62.5 L 94.22 53 L 89.47 43.5 Z",
    fill: "#39657e",
    stroke: "#39657e",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.4aac7d4c7543042e9d14306443e7f866.svg";
export { ForwardRef as ReactComponent };